import Promo from '../Promo/Promo.jsx';

const Main = () => (
  <main>
    <Promo/>
  </main>
);

export default Main;
